/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { getTypedKeys } from "~/tools";
import { GoogleJsonData, FormData } from "./types";

export function isJson(file: File) {
  return file.type === "application/json";
}

export function readFile<T>(file: File): Promise<T> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    // eslint-disable-next-line unicorn/prefer-add-event-listener
    reader.onload = function (event) {
      try {
        const result = event.target?.result;
        if (typeof result === "string") {
          const parsed = JSON.parse(result);
          resolve(parsed);
        }
      } catch {
        reject(new Error("Failed parsing file."));
      }
    };

    reader.readAsText(file);
  });
}

export function snakeToCamel(str: string) {
  return str.replaceAll(/([_-][a-z])/g, (group) =>
    group.toUpperCase().replace("-", "").replace("_", "")
  );
}

export function prepareData(data: GoogleJsonData) {
  return getTypedKeys(data).reduce((acc, curr) => {
    return {
      ...acc,
      [snakeToCamel(curr)]: data[curr],
    };
    // Auto-fix changes return type of a function to `string` which is wrong
    // eslint-disable-next-line @typescript-eslint/prefer-reduce-type-parameter
  }, {} as FormData);
}

export function hasFiles(list: FileList): boolean {
  return list.length > 0;
}
